import { Button, Card, CardActions, CardContent, Box } from '@mui/material';

interface ICardIcon {
    title?: string | any;
    onClick?: () => void;
    icon?: JSX.Element;
  }
  
function IconCard(props: ICardIcon) {
  const { title, onClick, icon } = props;
  
  return (
    <Box sx={{ '&:hover': { cursor: 'pointer' }, m: 1 }} onClick={onClick}>
      <Card sx={{ display: 'flex' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <CardContent sx={{ flex: '1 0 auto' }}>
            <div style={{
              minWidth: '100px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
              margin: '10px'
            }}>
              {icon}
            </div>
          </CardContent>
          <CardActions>
            <Box style={{ margin: 'auto' }}>
              <Button color='inherit' variant='text'
                style={{ fontSize: '1.2rem' }}
                sx={{ '&:hover': { backgroundColor: 'transparent' } }}>{title}</Button>
            </Box>
          </CardActions>
        </Box >
      </Card>
    </Box>
  );
}
  
export default IconCard;